export class StringCleanUtils {
  public static replaceInString(object) {
    let stringObject = object.toString();
    while (stringObject.includes('-') || stringObject.includes('.') || stringObject.includes('/')) {
      stringObject = stringObject.replace('-', '').replace('.', '').replace('/', '');
    }
    const result: number = +stringObject;
    return result;
  }


  // Remove acentos
  public static replaceSpecialChars(str) {
    const withDia = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    const withoutDia = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz'; 

    for (let i = 0; i < withDia.length; i++) {      
      str = str.replaceAll(withDia[i], withoutDia[i]);
    }

    return str;
  }

  public static titleize(text) {
    const loweredText = text.toLowerCase().trim();
    const words = loweredText.split(' ');
    for (let a = 0; a < words.length; a++) {
      let w = words[a];
      if (w.length > 1) {
        const firstLetter = w[0];
        w = firstLetter.toUpperCase() + w.slice(1);
      }
      words[a] = w;
    }
    return words.join(' ');
  }
}
